import {ITimeService} from './time.service.interface';
import {ServiceBase} from "../ServiceBase";
import DateFormatter from "../../../sdk/src/utils/date_formatter";
import {IDateFormattedToRegulationOffset} from '../sdk/cgp-sdk.interface';
import {UndefinedString} from '../../../common/types/nullable-types';

export class TimeService extends ServiceBase implements ITimeService {
  now(): number {
    return Date.now();
  }

  performanceNow(): number {
    return performance.now();
  }

  getCurrentDate(): Date {
    return new Date();
  }

  getCurrentServerDate(): Date {
    return this.services.sdk.getCurrentServerDate();
  }

  getTimeFormatToRegulationService(date: UndefinedString, dateFormattedToRegulation: UndefinedString): string {
    
    const lastLogin = this._formatToRegulationOffset(date, dateFormattedToRegulation);
    const formattedText = this._lastLoginFormattedText(lastLogin.date + 'Z', lastLogin.isUTC)
    return formattedText;
  }

  private _formatToRegulationOffset(date: UndefinedString, dateFormattedToRegulation: UndefinedString): IDateFormattedToRegulationOffset {
    return this.services.sdk.formatToRegulationOffset(date, dateFormattedToRegulation);
  }

  private _lastLoginFormattedText(lastLogin: Date | string, isUtc: boolean): string {
    return DateFormatter.format(lastLogin.toString(), this._getRegulationDateTimeFormat(), isUtc);
  }

  private _getRegulationDateTimeFormat(): string {
    return this.services.sdk.dateAndTimeFormat.dateTime || this.getDateTimeHistoryFormat();
  }

  getDateFormat(): string {
    return this.services.sdk.dateAndTimeFormat.date;
  }

  getTimeFormat(): string {
    return this.services.sdk.dateAndTimeFormat.time;
  }



  getDateTimeFormat(): string {
    return this.services.sdk.dateAndTimeFormat.dateTime;
  }

  getDateTimeHistoryFormat(): string {
    return this.services.sdk.dateAndTimeFormat.dateTimeHistory;
  }

  getTimezoneOffset(): number {
    return (new Date().getTimezoneOffset() / 60) * (-1);
  }

  formatHistoryRecordDateTime(date: Date | string, isUtc: boolean): string {
    return DateFormatter.format(date.toString(), this.getDateTimeHistoryFormat(), isUtc);
  }

}